var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Box, Divider, Icon, MenuIcon, Spinner, StylesProvider, chakra, createIcon, useColorModeValue, useMultiStyleConfig, useStyleConfig, useStyles, useTheme } from "@chakra-ui/react";
import { cleanCommonProps } from "./utils";

var SelectContainer = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    isDisabled,
    isRtl,
    selectProps: {
      chakraStyles
    }
  } = props;
  var initialStyles = {
    position: "relative",
    direction: isRtl ? "rtl" : undefined,
    // When disabled, react-select sets the pointer-state to none which prevents
    // the `not-allowed` cursor style from chakra from getting applied to the
    // Control when it is disabled
    pointerEvents: "auto"
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.container ? chakraStyles.container(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className),
    sx: sx
  }, innerProps), children);
};

var ValueContainer = props => {
  var {
    children,
    className,
    cx,
    isMulti,
    hasValue,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var px = {
    sm: "0.75rem",
    md: "1rem",
    lg: "1rem"
  };
  var initialStyles = {
    d: "flex",
    alignItems: "center",
    flex: 1,
    p: "0.125rem ".concat(px[size]),
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.valueContainer ? chakraStyles.valueContainer(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className),
    sx: sx
  }, children);
};

var IndicatorsContainer = props => {
  var {
    children,
    className,
    cx,
    selectProps: {
      chakraStyles
    }
  } = props;
  var initialStyles = {
    d: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    flexShrink: 0
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.indicatorsContainer ? chakraStyles.indicatorsContainer(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      indicators: true
    }, className),
    sx: sx
  }, children);
};

var Control = props => {
  var {
    className,
    cx,
    children,
    innerRef,
    innerProps,
    isDisabled,
    isFocused,
    menuIsOpen,
    selectProps: {
      size,
      isInvalid,
      chakraStyles,
      focusBorderColor,
      errorBorderColor
    }
  } = props;
  var inputStyles = useMultiStyleConfig("Input", {
    focusBorderColor,
    errorBorderColor,
    size
  });
  var heights = {
    sm: 8,
    md: 10,
    lg: 12
  };

  var initialStyles = _objectSpread(_objectSpread({}, inputStyles.field), {}, {
    d: "flex",
    p: 0,
    overflow: "hidden",
    h: "auto",
    minH: heights[size]
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.control ? chakraStyles.control(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: inputStyles
  }, /*#__PURE__*/React.createElement(Box, _extends({
    ref: innerRef,
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className),
    sx: sx
  }, innerProps, {
    "data-focus": isFocused ? true : undefined,
    "data-invalid": isInvalid ? true : undefined,
    "data-disabled": isDisabled ? true : undefined
  }), children));
};

var Placeholder = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      placeholderColor,
      chakraStyles
    }
  } = props;
  var initialStyles = {
    color: placeholderColor,
    mx: "0.125rem",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    userSelect: "none"
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.placeholder ? chakraStyles.placeholder(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      placeholder: true
    }, className),
    sx: sx
  }, innerProps), children);
}; // Multi Value


var MultiValue = props => {
  var {
    children,
    className,
    components,
    cx,
    data,
    innerProps,
    isDisabled,
    isFocused,
    removeProps,
    selectProps
  } = props;
  var {
    Container,
    Label,
    Remove
  } = components;
  var {
    chakraStyles,
    colorScheme,
    tagVariant,
    size
  } = selectProps;
  var {
    container,
    closeButton,
    label
  } = useMultiStyleConfig("Tag", {
    size,
    colorScheme: data.colorScheme || colorScheme,
    variant: data.variant || tagVariant || (data.isFixed ? "solid" : "subtle")
  });

  var containerInitialStyles = _objectSpread(_objectSpread({
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%"
  }, container), {}, {
    m: "0.125rem"
  });

  var containerSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValue ? chakraStyles.multiValue(containerInitialStyles, props) : containerInitialStyles;
  var labelSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValueLabel ? chakraStyles.multiValueLabel(label, props) : label;

  var removeInitialStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, closeButton);

  var removeSx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.multiValueRemove ? chakraStyles.multiValueRemove(removeInitialStyles, props) : removeInitialStyles;
  return /*#__PURE__*/React.createElement(Container, {
    data: data,
    innerProps: _objectSpread({
      className: cx({
        "multi-value": true,
        "multi-value--is-disabled": isDisabled
      }, className)
    }, innerProps),
    sx: containerSx,
    selectProps: selectProps
  }, /*#__PURE__*/React.createElement(Label, {
    data: data,
    innerProps: {
      className: cx({
        "multi-value__label": true
      }, className)
    },
    sx: labelSx,
    selectProps: selectProps
  }, children), /*#__PURE__*/React.createElement(Remove, {
    data: data,
    innerProps: _objectSpread({
      className: cx({
        "multi-value__remove": true
      }, className),
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps),
    sx: removeSx,
    selectProps: selectProps,
    isFocused: isFocused
  }));
};

var MultiValueContainer = props => {
  var {
    children,
    innerProps,
    sx
  } = props;
  return /*#__PURE__*/React.createElement(chakra.span, _extends({}, innerProps, {
    sx: sx
  }), children);
};

var MultiValueLabel = props => {
  var {
    children,
    innerProps,
    sx
  } = props;
  return /*#__PURE__*/React.createElement(chakra.span, _extends({}, innerProps, {
    sx: sx
  }), children);
}; // https://github.com/chakra-ui/chakra-ui/blob/main/packages/tag/src/tag.tsx#L75


var TagCloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  verticalAlign: "inherit",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
}));

var MultiValueRemove = props => {
  var {
    children,
    innerProps,
    isFocused,
    data,
    sx
  } = props;

  if (data.isFixed) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Box, _extends({}, innerProps, {
    role: "button",
    sx: sx,
    "data-focus": isFocused ? true : undefined
  }), children || /*#__PURE__*/React.createElement(TagCloseIcon, null));
}; // Single Value


var SingleValue = props => {
  var {
    children,
    className,
    cx,
    isDisabled,
    innerProps,
    selectProps: {
      chakraStyles
    }
  } = props;
  var initialStyles = {
    label: "singleValue",
    mx: "0.125rem",
    maxWidth: "calc(100% - 0.5rem)",
    overflow: "hidden",
    position: "absolute",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    top: "50%",
    transform: "translateY(-50%)"
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.singleValue ? chakraStyles.singleValue(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className),
    sx: sx
  }, innerProps), children);
}; // Indicators


var IndicatorSeparator = props => {
  var {
    className,
    cx,
    selectProps: {
      chakraStyles
    }
  } = props;
  var initialStyles = {
    opacity: 1
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.indicatorSeparator ? chakraStyles.indicatorSeparator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Divider, {
    className: cx({
      "indicator-separator": true
    }, className),
    sx: sx,
    orientation: "vertical"
  });
};

var CloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  focusable: "false",
  "aria-hidden": true
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
}));

var ClearIndicator = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    isFocused,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var closeButtonStyles = useStyleConfig("CloseButton", {
    size: size
  });

  var initialStyles = _objectSpread(_objectSpread({}, closeButtonStyles), {}, {
    mx: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer"
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.clearIndicator ? chakraStyles.clearIndicator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "button",
    className: cx({
      indicator: true,
      "clear-indicator": true
    }, className),
    sx: sx,
    "data-focused": isFocused ? true : undefined,
    "aria-label": "Clear selected options"
  }, innerProps), children || /*#__PURE__*/React.createElement(CloseIcon, {
    width: "1em",
    height: "1em"
  }));
}; // Taken from the @chakra-ui/icons package to prevent needing it as a dependency
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/icons/src/ChevronDown.tsx


var ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});

var DownChevron = props => /*#__PURE__*/React.createElement(ChevronDownIcon, props);

var DropdownIndicator = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var {
    addon
  } = useStyles();
  var iconSizes = {
    sm: 4,
    md: 5,
    lg: 6
  };
  var iconSize = iconSizes[size];

  var initialStyles = _objectSpread(_objectSpread({}, addon), {}, {
    d: "flex",
    alignItems: "center",
    justifyContent: "center",
    h: "100%",
    borderRadius: 0,
    borderWidth: 0,
    cursor: "pointer"
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.dropdownIndicator ? chakraStyles.dropdownIndicator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({}, innerProps, {
    className: cx({
      indicator: true,
      "dropdown-indicator": true
    }, className),
    sx: sx
  }), children || /*#__PURE__*/React.createElement(DownChevron, {
    h: iconSize,
    w: iconSize
  }));
};

var LoadingIndicator = props => {
  var {
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var spinnerSizes = {
    sm: "xs",
    md: "sm",
    lg: "md"
  };
  var spinnerSize = spinnerSizes[size];
  var initialStyles = {
    mr: 3
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.loadingIndicator ? chakraStyles.loadingIndicator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Spinner, _extends({
    className: cx({
      indicator: true,
      "loading-indicator": true
    }, className),
    sx: sx
  }, innerProps, {
    size: spinnerSize
  }));
}; // Menu components


var Menu = props => {
  var {
    className,
    cx,
    children,
    innerProps,
    innerRef,
    placement,
    selectProps: {
      chakraStyles
    }
  } = props;
  var menuStyles = useMultiStyleConfig("Menu", {});

  var initialStyles = _objectSpread(_objectSpread(_objectSpread({
    position: "absolute"
  }, placement === "bottom" && {
    top: "100%"
  }), placement === "top" && {
    bottom: "100%"
  }), {}, {
    my: "8px",
    w: "100%",
    zIndex: 1,
    overflow: "hidden"
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.menu ? chakraStyles.menu(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: innerRef,
    className: cx({
      menu: true
    }, className),
    sx: sx
  }, innerProps), /*#__PURE__*/React.createElement(StylesProvider, {
    value: menuStyles
  }, children));
};

var MenuList = props => {
  var {
    className,
    cx,
    innerRef,
    children,
    maxHeight,
    isMulti,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var {
    list
  } = useStyles();
  var borderRadii = useTheme().radii;

  var initialStyles = _objectSpread(_objectSpread({}, list), {}, {
    maxH: "".concat(maxHeight, "px"),
    overflowY: "auto",
    borderRadius: borderRadii[size]
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.menuList ? chakraStyles.menuList(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    sx: sx,
    ref: innerRef
  }, children);
};

var Group = props => {
  var {
    children,
    className,
    cx,
    theme,
    getStyles,
    Heading,
    headingProps,
    label,
    selectProps
  } = props;
  var {
    chakraStyles
  } = selectProps;
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.group ? chakraStyles.group({}, props) : {};
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      group: true
    }, className),
    sx: sx
  }, /*#__PURE__*/React.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    cx: cx,
    theme: theme,
    getStyles: getStyles
  }), label), /*#__PURE__*/React.createElement(Box, null, children));
};

var GroupHeading = props => {
  var {
    cx,
    className,
    children,
    selectProps: {
      size,
      hasStickyGroupHeaders,
      chakraStyles
    }
  } = props;
  var {
    groupTitle,
    list: {
      bg
    }
  } = useStyles();
  var chakraTheme = useTheme();
  var fontSizes = {
    sm: chakraTheme.fontSizes.xs,
    md: chakraTheme.fontSizes.sm,
    lg: chakraTheme.fontSizes.md
  };
  var paddings = {
    sm: "0.4rem 0.8rem",
    md: "0.5rem 1rem",
    lg: "0.6rem 1.2rem"
  };

  var initialStyles = _objectSpread(_objectSpread({}, groupTitle), {}, {
    fontSize: fontSizes[size],
    p: paddings[size],
    m: 0,
    borderBottomWidth: hasStickyGroupHeaders ? "1px" : 0,
    position: hasStickyGroupHeaders ? "sticky" : "static",
    top: -2,
    bg
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.groupHeading ? chakraStyles.groupHeading(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      "group-heading": true
    }, className),
    sx: sx
  }, children);
}; // Use the CheckIcon component from the chakra menu
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/menu/src/menu.tsx#L301


var CheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
}));

var Option = props => {
  var _itemStyles$_focus;

  var {
    className,
    cx,
    innerRef,
    innerProps,
    children,
    isFocused,
    isDisabled,
    isSelected,
    selectProps: {
      size,
      isMulti,
      hideSelectedOptions,
      selectedOptionStyle,
      selectedOptionColor,
      chakraStyles
    }
  } = props;
  var itemStyles = useStyles().item;
  var paddings = {
    sm: "0.3rem 0.6rem",
    md: "0.4rem 0.8rem",
    lg: "0.5rem 1rem"
  }; // Use the same selected color as the border of the select component
  // https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/input.ts#L73

  var selectedBg = useColorModeValue("".concat(selectedOptionColor, ".500"), "".concat(selectedOptionColor, ".300"));
  var selectedColor = useColorModeValue("white", "black"); // Don't create exta space for the checkmark if using a multi select with
  // options that dissapear when they're selected

  var showCheckIcon = selectedOptionStyle === "check" && (!isMulti || hideSelectedOptions === false);
  var shouldHighlight = selectedOptionStyle === "color" && isSelected;

  var initialStyles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, itemStyles), {}, {
    d: "flex",
    alignItems: "center",
    w: "100%",
    textAlign: "start",
    fontSize: size,
    p: paddings[size],
    bg: isFocused ? (_itemStyles$_focus = itemStyles._focus) === null || _itemStyles$_focus === void 0 ? void 0 : _itemStyles$_focus.bg : "transparent"
  }, shouldHighlight && {
    bg: selectedBg,
    color: selectedColor,
    _active: {
      bg: selectedBg
    }
  }), isDisabled && itemStyles._disabled), isDisabled && {
    _active: {}
  });

  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.option ? chakraStyles.option(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "button",
    className: cx({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    sx: sx,
    ref: innerRef
  }, innerProps, {
    disabled: isDisabled ? true : undefined
  }), showCheckIcon && /*#__PURE__*/React.createElement(MenuIcon, {
    fontSize: "0.8em",
    marginEnd: "0.75rem",
    opacity: isSelected ? 1 : 0
  }, /*#__PURE__*/React.createElement(CheckIcon, null)), children);
}; // Messages


var LoadingMessage = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      placeholderColor,
      chakraStyles
    }
  } = props;
  var fontSizes = {
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem"
  };
  var paddings = {
    sm: "6px 9px",
    md: "8px 12px",
    lg: "10px 15px"
  };
  var initialStyles = {
    color: placeholderColor,
    textAlign: "center",
    p: paddings[size],
    fontSize: fontSizes[size]
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.loadingMessage ? chakraStyles.loadingMessage(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className),
    sx: sx
  }, innerProps), children);
};

var NoOptionsMessage = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      placeholderColor,
      chakraStyles
    }
  } = props;
  var fontSizes = {
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem"
  };
  var paddings = {
    sm: "6px 9px",
    md: "8px 12px",
    lg: "10px 15px"
  };
  var initialStyles = {
    color: placeholderColor,
    textAlign: "center",
    p: paddings[size],
    fontSize: fontSizes[size]
  };
  var sx = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.noOptionsMessage ? chakraStyles.noOptionsMessage(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className),
    sx: sx
  }, innerProps), children);
};

var Input = props => {
  var {
    className,
    cx,
    value,
    selectProps: {
      chakraStyles
    }
  } = props;

  var _cleanCommonProps = cleanCommonProps(props),
      {
    innerRef,
    isDisabled,
    isHidden,
    inputClassName
  } = _cleanCommonProps,
      innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded);

  var spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minW: "2px",
    border: 0,
    m: 0,
    outline: 0
  };
  var initialContainerStyles = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    color: "inherit",
    _after: _objectSpread({
      content: 'attr(data-value) " "',
      visibility: "hidden",
      whiteSpace: "pre",
      p: 0
    }, spacingStyle)
  };
  var containerStyles = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.inputContainer ? chakraStyles.inputContainer(initialContainerStyles, props) : initialContainerStyles;

  var initialInputStyles = _objectSpread({
    label: "input",
    color: "inherit",
    bg: 0,
    opacity: isHidden ? 0 : 1,
    w: "100%",
    py: "0.125rem"
  }, spacingStyle);

  var inputStyles = chakraStyles !== null && chakraStyles !== void 0 && chakraStyles.input ? chakraStyles.input(initialInputStyles, props) : initialInputStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      "input-container": true
    }, className),
    "data-value": value || "",
    sx: containerStyles
  }, /*#__PURE__*/React.createElement(chakra.input, _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    sx: inputStyles,
    disabled: isDisabled
  }, innerProps)));
};

var chakraComponents = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  Group,
  GroupHeading,
  IndicatorSeparator,
  IndicatorsContainer,
  Input,
  LoadingIndicator,
  LoadingMessage,
  Menu,
  MenuList,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  NoOptionsMessage,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
export default chakraComponents;
//# sourceMappingURL=chakra-components.js.map